<div mat-dialog-title class="dialog-info" closeOnEscape>
    <label class="dialogTitle">
        {{'RISK' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>

<div [formGroup]="riskForm">
    <div class="col-md-12 pr-0">
        <mat-dialog-content class="contentPadding">
            <div>
                <mat-label class="bold">
                    {{ 'RISK_RATE_INSTRUCTION' | translate }}
                </mat-label><br/><br/>
                <mat-label class="bold">
                    {{ 'RISK_RATE_NOTE' | translate }}
                </mat-label>
            </div><br/>
            <div class="table-responsive">
                <div>
                    <table mat-table [dataSource]="riskDataSource" class="mat-elevation-z1">
                        <ng-container matColumnDef="title">
                            <th mat-header-cell *matHeaderCellDef class="title-align-head center-align"></th>
                            <td mat-cell *matCellDef="let element" class="title-align-row tableDefination"> 
                                {{element.title | translate}} 
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="rate">
                            <th mat-header-cell *matHeaderCellDef class="center-align"> 
                                {{'RATE' | translate}} 
                            </th>
                            <td mat-cell *matCellDef="let element" class="tableDefination center-align"> 
                                <mat-form-field appearance="outline" class="form-field-size" >
                                    <input matInput 
                                    [appNumericMask]="rateConfig"
                                    inputmode="decimal"
                                    class="input-alignment form-input" 
                                    formControlName="rate" 
                                    >
                                </mat-form-field> 
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="dollars">
                            <th mat-header-cell *matHeaderCellDef class="center-align"> 
                                {{'DOLLARS' | translate}} 
                            </th>
                            <td mat-cell *matCellDef="let element" class="tableDefination center-align"> 
                                {{element.dollars | multilingualCurrency}}
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="tdcPercent">
                            <th mat-header-cell *matHeaderCellDef class="center-align"> 
                                % {{'OF_TDC' | translate}} 
                            </th>
                            <td mat-cell *matCellDef="let element" class="tableDefination center-align"> 
                                {{element.tdcPercent | decimalPrecision}}%
                            </td>
                        </ng-container>
    
                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="rowHeight"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="rowHeight tableDefination"></tr>
                    </table>
                </div>
            </div>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="actionsPadding">
            <div>
                <button class="openCloseBtn" mat-raised-button color="primary" (click)="onSave()">{{'COMMON_DIALOGS_BTN_LABELS_OK' | translate}}</button>
                <button class="openCloseBtn" mat-raised-button color="warn" [mat-dialog-close]>{{'COMMON_DIALOGS_BTN_LABELS_CANCEL' | translate}}</button>
            </div>
        </mat-dialog-actions>
    </div>
</div>